import Loader from "./loader";

const loader = new Loader();

export const getSearchWidget = async ({ view, config }) => {
  const {
    modules: [Search, Locator, request, Polygon],
  } = await loader.load([
    "esri/widgets/Search",
    "esri/tasks/Locator",
    "esri/request",
    "esri/geometry/Polygon",
  ]);
  const url = `${config.baseUrl}/queryBoundary?outSR=&f=json`;
  const responseData = await fetch(url).then((response) => response.json()).catch(error => console.log("search widget error: ", error));
  const {
    shape: { rings, spatialReference },
  } = responseData;

  const polygon = new Polygon({
    hasM: true,
    hasZ: true,
    rings,
    spatialReference,
  });
  const source = {
    locator: new Locator({
      url: "//geocode.arcgis.com/arcgis/rest/" + "services/World/GeocodeServer",
      countryCode: "US",
    }),
    countryCode: "US",
    filter: {
      where: `Addr_type LIKE "%, ID,%`,
      geometry: polygon,
    },
    singleLineFieldName: "SingleLine",
    outFields: ["Addr_type"],
    autoNavigate: true,
  };
  const searchConfig = {
    view,
    locationEnabled: true,
    popupEnabled: false,
    popupOpenOnSelect: false,
    autoSelect: true,
    sources: [source],
    includeDefaultSources: true,
  };
  return new Search(searchConfig);
};
